import React from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons'


import 'bootstrap/dist/css/bootstrap.css';
import '../Styles/shared.css';
import '../Styles/HomePage.css';

const HomePage = () => {
    return (

        <div>


            {/* introduction */}
            <div className="introduction" id="introduction">
                <Row className="">
                    <div className="content-text-center content-center  mt-4">
                        <img className="App-logo img-fluid rounded-circle nav-company-logo border" src="./Assets/logo.png"></img>
                    </div>
                    <div className="col-12 d-flex justify-content-center mt-2 text-color-primary">
                        <h3>پارسی پل خودران</h3>
                    </div>
                    <div className="col-12 d-flex justify-content-center content-text-center mb-4 text-muted">
                        <h6 className="CompanyTrademark">اولین تولید کننده اتوماسیون های آزمایشگاهی در ایران</h6>
                    </div>

                    <div className="col-12 d-flex justify-content-center mb-5">
                        <div className="CompanyDescription text-justify text-right">
                            <p>پارسیپل خودران با تجربه و اندوخته بیش از 25 سال در تولید نرم افزار از کشور آمریکا در سال 1384 شروع به تولید اولین سیستم اتوماسیون و مکانیزاسیون در ایران نمود . در حال حاضرسیستم جامع اتوماسیون و مکانیزاسیون آزمایشگاه در صدها آزمایشگاه ، از جمله 100 آزمایشگاه بزرگ کشور در حال سرویس دهی بصورت پوشش جامع و تمام اتوماته می باشد . طراحی و تولید این سیستم با بهره گیری از تجربه تولید نرم افزار و علمی اتومکانیزاسیون ، تکنولوژی های نوین ، استاندارد های جهانی در حوضه نرم افزار ، سلامت و آزمایشگاه و استفاده از متخصصین داخلی انجام شده است .
                            این سیستم با توسعه و ایجاد ارتباطات لازم و پیشرو با سیستم های سخت افزاری و شبکه ، آنالیزور ها ، وب ، موبایل ، ربات ، تلگرام ، تلویزیون ، استند های نوبت دهی و سلف سرویس ، تاچ ، بی سیم ، پوز بانکی ، سیستم کنترل دما و رطوبت ، پرداخت آنلاین ، ارتباط رویایی و تمام اتوماتیک آزمایشگاهها از طریق اینترانت ، جواب یکجا و دسترسی آسان ، یکپارچه و اتوماتیک ، دسترسی ها و گزینه های لازم را برای بیمار ، پرشک ، نمونه گیرخارج از مرکز، مسئولین فنی ، مراکز ارسالی و شرکتها ، را برای آزمایشگاه ها بصورت یکپارچه و آنلاین فراهم آورده است .</p>
                        </div>
                    </div>


                </Row>
            </div>

            {/* production */}
            <div className="production p-5" id="production">
                <Row className="mb-3">
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center  text-color-primary">لینک کوتاه جواب یکپارچه</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image">
                                    <img className="img-fluid border" src="./Assets/Mobile5.png"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text"> به محض آماده شدن جواب بیمار یک پیامک شامل لینک دانلود جواب کامل شامل ضمائم برای بیمار ارسال می شود و مراجعه کننده بدون مراجعه حضوری میتواند جواب خود را با امضای الکترونیک به صورت غیر حضوری دریافت کند</p>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center text-color-primary">پارسی لب ، آزمایشگاه همراه</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image">
                                    <img className="img-fluid border" src="./Assets/android.parsic.parsilab5.jpg"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text">با اپلیکیشن موبایل پارسی لب می توانید به جواب آزمایش خود در تمامی آزمایشگاه های مطرح کشور دسترسی داشته باشید و همچنین می توانید درخواست نمونه گیری درب منزل به نزدیک ترین آزمایشگاه در شهر خود داشته باشید</p>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center text-color-primary">اتوماسیون جامع آزمایشگاهی</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image-square">
                                    <img className="img-fluid border" src="./Assets/monitoring.png"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text">اتوماسیون آزمایشگاهی پارسیپل ، اولین نرم افزار جامع اتوماسیون و مکانیزاسیون آزمایشگاهی ، از ورود بیمار به آزمایشگاه (نوبت دهی) تا تحویل جواب که شامل 17 فرآیند کامل میگردد را به صورت اتوماته ، بدون کاغذ و با کمترین نیروی انسانی پوشش می دهد</p>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>

                <Row className="mb-3">
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center text-color-primary">پارسی تمپ ، کنترل درجه حرارت</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image-square">
                                    <img className="img-fluid border" src="./Assets/parsitemp.jpeg"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text">سامانه کنترل درجه حرارت پارسی تمپ به صورت 2 و  6  کاناله با قابلیت اتصال بی سیم میزان درجه حرارت و رطوبت محیط را ضبط می کند و در صورت نقض شدن هر کدام از شرایط از قبل تعریف شده مدیر سیستم را به وسیله پیامک از وجود مشکل آگاه می سازد</p>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center text-color-primary">پارسی تل ، مدیریت آزمایشگاه همراه</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image">
                                    <img className="img-fluid border" src="./Assets/parsitel.jpeg"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text">اپلیکیشن موبایل پارسیتل به مدیران آزمایشگاه این امکان را می دهد که هر لحظه بتوانند آزمایشگاه را از راه دور کنترل کنند ؛ کنترل مالی ، سرعت کار پرسنل ، دماسنج ها ، کنترل کیفی ، انبارداری و تایید جواب های آماده از امکانات اصلی این اپلیکیشن می باشد</p>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col className="mb-2" sm="12" md="6" lg="4" xl="4" p-3 h-150>
                        <Card className="box-customize-border-shadow box-opacity-hover">
                            <CardHeader className="bg-transparent d-flex justify-content-center text-color-primary">جوابدهی آنلاین سایت</CardHeader>
                            <CardBody>
                                <div className="d-flex content-center product-description-image-square">
                                    <img className="img-fluid border" src="./Assets/web.png"></img>
                                </div>
                                <p className=" mt-3 card-text d-flex justify-content-center text-justify text-right product-description-text">با جوابدهی آنلاین ، تمامی نیازهای آنلاین بیماران آزمایشگاه ، مراکز طرف های قرارداد ، پزشکان و همچنین کاربران آزمایشگاه را در اختیار گذاشت. از جمله این امکانات می توان به دانلود جواب ، پرداخت بدهی توسط بیماران و آزمایشگاه های طرف قرارداد اشاره کرد</p>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>

            </div>


            {/* Customers */}
            <div className="Customers" id="customers">
                <Row>
                    <div className="col-12 d-flex justify-content-center mt-5 text-color-primary">
                        <h3 className="content-text-center">بیش از 500 آزمایشگاه در سراسر کشور به ما اعتماد داشتند</h3>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                        <div className="mt-3 p-3 content-text-center">
                            <Row>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="https://www.niloulab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_niloutehran_login.png" alt="آزمایشگاه نیلو تهران" ></img></a>
                                        <p className="customer-logo-text text-muted">نیلو تهران</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="https://www.parsehlab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_parsehtehran_login.png" alt="آزمایشگاه پارسه تهران" ></img></a>
                                        <p className="customer-logo-text text-muted">پارسه تهران</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://baharmedlab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_bahartehran_login.png" alt="آزمایشگاه بهار تهران" ></img></a>
                                        <p className="customer-logo-text text-muted">بهار تهران</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://boghratlab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_boghrattehran_login.png" alt="آزمایشگاه بقراط تهران" ></img></a>
                                        <p className="customer-logo-text text-muted">بقراط تهران</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://pardislab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_pardismashhad_login.png" alt="آزمایشگاه پردیس مشهد" ></img></a>
                                        <p className="customer-logo-text text-muted">پردیس مشهد</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://www.payvandlab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_peyvandtehran_login.png" alt="آزمایشگاه پیوند تهران" ></img></a>
                                        <p className="customer-logo-text text-muted">پیوند تهران</p>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="https://www.miladlab.ir/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_miladesfehan_login.png" alt="آزمایشگاه میلاد اصفهان" ></img></a>
                                        <p className="customer-logo-text text-muted">میلاد اصفهان</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://danesh-2lab.com/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_danesh1tabriz_login.png" alt="آزمایشگاه دانش تبریز" ></img></a>
                                        <p className="customer-logo-text text-muted">مجموعه آزمایشگاه های دانش تبریز</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="https://esf.piho.ir/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_naftesfahandarvazehtehran_login.png" alt="شبکه بهداشت نفت" ></img></a>
                                        <p className="customer-logo-text text-muted">شرکت نفت</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://jdmlabs.ir/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_jahaddaneshgahigonabad_login.png" alt="جهاد دانشگاهی" ></img></a>
                                        <p className="customer-logo-text text-muted">جهاد دانشگاهی</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="https://www.daneshbodlab.com/fa/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_drdaneshbodshiraz_login.png" alt="آزمایشگاه دکتر دانشبد شیراز" ></img></a>
                                        <p className="customer-logo-text text-muted">دکتر دانشبد شیراز</p>
                                    </div>
                                </Col>
                                <Col sm="6" md="6" lg="2" xl="2">
                                    <div className="box-opacity-hover">
                                        <a href="http://drdabirilab.ir/" target="_blank"><img className="img-fluid rounded-circle border customer-logo-img content-center" src="./LabIcons/lablogo_drdabiri_login.png" alt="آزمایشگاه دکتر دبیری کرمان" ></img></a>
                                        <p className="customer-logo-text text-muted">دکتردبیری کرمان</p>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                    </div>


                </Row>
            </div>



            {/* Contact */}
            <div className="Contact" id="contact">
                <footer class="page-footer font-small mdb-color pt-4">
                    <div class="container text-center text-md-left">
                        <div class="row text-center text-md-left mt-3 pb-3">


                            <div class="col-md-3 col-lg-2 col-xl-4 mx-auto mt-3">
                                <h6 class="text-uppercase mb-4 font-weight-bold content-text-center">مجوزها</h6>
                                <img className="img-fluid" src="./Assets/enamad-one-star.png" alt="" ></img>
                                <img className="img-fluid" src="./Assets/samandehi.png" alt="" ></img>
                            </div>


                            <hr class="w-100 clearfix d-md-none"></hr>


                            <div class="col-md-3 col-lg-2 col-xl-4 mx-auto mt-3">
                                <h6 class="text-uppercase mb-4 font-weight-bold content-text-center">لینک های مفید</h6>
                                <p className="content-text-center">
                                    <a  href="http://www.parsipol.com/">پارسی پل خودران</a>
                                </p>
                                <p className="content-text-center">
                                    <a href="http://services.irannsr.org/">سازمان نظام صنفی رایانه ای</a>
                                </p>
                                <p className="content-text-center">
                                    <a href="https://behdasht.gov.ir/">وزارت بهداشت</a>
                                </p>
                                <p className="content-text-center"> 
                                    <a href="https://ihio.gov.ir/">بیمه سلامت</a>
                                </p>
                                <p className="content-text-center">
                                    <a href="https://tamin.ir/">تامین اجتماعی</a>
                                </p>
                            </div>

                            <hr class="w-100 clearfix d-md-none"></hr>

                            <div class="col-md-4 col-lg-3 col-xl-4 mx-auto mt-3 ">
                                <h6 class="text-uppercase mb-4 font-weight-bold text-right">راه های ارتباطی</h6>
                                <p className="text-right">
                                    تهران ، اشرفی اصفهانی ، ضلع شمال غربی تقاطع نیایش و اشرفی اصفهانی ، کوچه پنجم غربی پلاک 8 </p>
                                <p className="text-right">
                                    info@parsipol.com <FontAwesomeIcon icon={faEnvelope} /></p>
                                <p className="text-right">
                                    021-49951000 <FontAwesomeIcon icon={faPhone} /></p>
                                <p className="text-right">
                                    021-44804472 <FontAwesomeIcon icon={faPhone} /></p>
                            </div>

                        </div>
                    </div>
                </footer>
            </div>



        </div>


    );
}

export default HomePage;